import React, { Component } from "react";
import { Button, Form, Image } from "react-bootstrap";
import FileComponent from "../ImageUploadComponent";
import { ERROR_MSG, DOCUMENT_FORMATS, STATUS } from "../../constant";
import IconPin from "../../assets/icon-pin.png";
import Forma from "../../assets/Forma 1.svg";
import { Field } from "../../component";
import { get, isBuffer } from "lodash";
import { connect } from "react-redux";
import { LoaderPage } from "../../component/Loader";
import { bindActionCreators } from "redux";
import { setIssueStatusAction } from "../../actions/issuesListAction.actions";
import { getIssueList } from "../../actions/common.action";
import { toast } from "react-toastify";
import {
  UploadAttachmentsWithTitleComponent
  //DisplayAttachments
} from "../reusableComponent";
import { DisplayAttachments } from "../reusableComponent/displayAttachments/indexForward";
import { successToastStyle, errorToastStyle } from "../../customToast";
import htmlToFormattedText from "html-to-formatted-text";
import { ConfirmationComponent } from "../ConfirmationComponent";
const ACTION_TYPE = "WITH_COMMENT";

class ChangeStatus extends Component {
  state = {
    template: [],
    files: [],
    error: {},
    comment: "",
    showCommentPopUp: false
  };

  onChange = (value, key) => {
    //console.log("3333333333333", value, key);
    this.setState({
      [key]: value
    });
  };

  toggleMeetingPopUp = () => {
    this.setState({ showCommentPopUp: false }, () => {
      //console.log(this.state.showCommentPopUp);
    });
  };

  onError = (value, key) => {
    this.setState(prevState => ({
      error: {
        ...prevState.error,
        [key]: value
      }
    }));
  };

  onSend = () => {
    const { sendTo, comment, error } = this.state;
    const { actionType } = this.props;

    if (
      actionType === ACTION_TYPE &&
      ((comment === undefined || !comment.trim()) &&
        (!get(error, "comment") || get(error, "comment.error")))
    ) {
      this.setState(prevState => ({
        error: {
          ...prevState.error,
          comment: {
            error: comment === undefined || !comment.trim(),
            message:
              comment === undefined || !comment.trim()
                ? ERROR_MSG.DEFAULT_MSG
                : ""
          }
        }
      }));
    } else {
      this.setState({
        sendTo: !sendTo,
        showCommentPopUp: true
      });
    }
  };
  onBlur = value => {};
  onDelete = e => {
    this.props.onCloseButton("1");
    const { resetAction } = this.props;
    resetAction(e);
  };

  // set issue status
  setIssueStatus = async e => {
    this.setState({ showCommentPopUp: false });
    const { comment, files } = this.state;
    const {
      setIssueStatusDispatch,
      callApiOnSuccess,
      action,
      issueDetails,
      isIssueList
    } = this.props;
    const resp = await setIssueStatusDispatch(undefined, {
      action,
      issueCommentCO: {
        comment: htmlToFormattedText(comment),
        fids: (files || []).map(value => +value.id),
        issueId: get(issueDetails, "id", null)
      }
    });
    if (resp) {
      if (!isIssueList) {
        setTimeout(() => {
          window.location.reload(true);
        }, 1500);
      }

      const { status, message } = resp;
      (status &&
        toast.success(
          <p className="toast-text-alignment">{message}</p>,
          successToastStyle
        )) ||
        toast.error(
          <p className="toast-text-alignment">{message}</p>,
          errorToastStyle
        );
      callApiOnSuccess(e);
    }
  };

  getImageStatus = status => {
    this.setState({
      imageStatus: status
    });
  };

  onSuccessUploadOfAttachmets = async data => {
    try {
      this.setState(prevState => ({ files: [...prevState.files, data] }));
    } catch (error) {
      console.error(error.message);
    }
  };

  // uploded comes tru in case of file
  // is uploaded
  onToggleAttachment = index => {
    this.setState(prevState => {
      return {
        toggleAttachementDisplay: !prevState.toggleAttachementDisplay
      };
    });
  };

  // delete attachments
  onRemoveFile = ({ id }) => {
    try {
      this.setState(prevState => ({
        files: prevState.files.filter(val => val.id !== id)
      }));
    } catch (error) {
      console.log(`Error while deleting the image ${error.message}`);
    }
  };

  render() {
    const {
      template,
      sendTo,
      error,
      files,
      toggleAttachementDisplay,
      showCommentPopUp
    } = this.state;
    if (this.state.comment !== null && this.state.comment !== undefined) {
      //console.log("valuewwwwwwwwwwwwwwwwwww", this.state.comment.length);
    }
    const { isImageUpLoading, headerText, action, issueDetails } = this.props;
    const parentId = issueDetails.parent || null;
    //console.log("parentIdChangeStatus", parentId);
    let displayvar;
    if (action === "RESOLVED & SEND TO PMG" || action === "RESOLVE") {
      displayvar = "Resolve Issue";
    } else if (action === "REJECT ISSUE" || action === "REJECT") {
      displayvar = "Reject Issue";
    } else {
      displayvar = "Add Reason to Change Status";
    }

    const meetingOm = [
      {
        id: 13954,
        title:
          "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
        mineType: "image/png",
        name: "2024-03-02_14h07_59.png",
        s3Url:
          "https://pmiic-local-files.s3.ap-south-1.amazonaws.com/1710738470969-2024-03-02_14h07_59.png",
        s3FileName: null
      },
      {
        id: 13955,
        title: "long name.",
        mineType: "image/png",
        name: "2024-03-02_14h07_59.png",
        s3Url:
          "https://pmiic-local-files.s3.ap-south-1.amazonaws.com/1710738470969-2024-03-02_14h07_59.png",
        s3FileName: null
      },
      {
        id: 13955,
        title: "long name.",
        mineType: "image/png",
        name: "2024-03-02_14h07_59.png",
        s3Url:
          "https://pmiic-local-files.s3.ap-south-1.amazonaws.com/1710738470969-2024-03-02_14h07_59.png",
        s3FileName: null
      },
      {
        id: 13955,
        title: "long name.",
        mineType: "image/png",
        name: "2024-03-02_14h07_59.png",
        s3Url:
          "https://pmiic-local-files.s3.ap-south-1.amazonaws.com/1710738470969-2024-03-02_14h07_59.png",
        s3FileName: null
      },
      {
        id: 13955,
        title: "long name.",
        mineType: "image/png",
        name: "2024-03-02_14h07_59.png",
        s3Url:
          "https://pmiic-local-files.s3.ap-south-1.amazonaws.com/1710738470969-2024-03-02_14h07_59.png",
        s3FileName: null
      },
      {
        id: 13955,
        title: "long name.",
        mineType: "image/png",
        name: "2024-03-02_14h07_59.png",
        s3Url:
          "https://pmiic-local-files.s3.ap-south-1.amazonaws.com/1710738470969-2024-03-02_14h07_59.png",
        s3FileName: null
      },
      {
        id: 13955,
        title: "long name.",
        mineType: "image/png",
        name: "2024-03-02_14h07_59.png",
        s3Url:
          "https://pmiic-local-files.s3.ap-south-1.amazonaws.com/1710738470969-2024-03-02_14h07_59.png",
        s3FileName: null
      },
      {
        id: 13955,
        title: "long name.",
        mineType: "image/png",
        name: "2024-03-02_14h07_59.png",
        s3Url:
          "https://pmiic-local-files.s3.ap-south-1.amazonaws.com/1710738470969-2024-03-02_14h07_59.png",
        s3FileName: null
      }
    ];

    return (
      <div className="change-status forward-to-team">
        {toggleAttachementDisplay ? (
          <UploadAttachmentsWithTitleComponent
            displayModal={toggleAttachementDisplay}
            onCloseModal={this.onToggleAttachment}
            fileFormats={DOCUMENT_FORMATS}
            onSubmit={this.onSuccessUploadOfAttachmets}
          />
        ) : null}

        <Form
          className={`forward-to-team-form-reject ${get(
            error,
            "comment.error"
          ) && "error-field"}`}
          style={{
            marginTop: window.location.pathname == "/issue-detail" ? "12px" : ""
          }}
        >
          <div
            //style={{ borderBottom: "1px solid #C4C4C4", width: "100%" }}
            className="forward-to-team-main-div-reject"
          >
            <div className="heading">{displayvar}</div>
            <div
              //className="btn-icon remove-issue-fwd"
              className="delete-padding"
              title="Delete"
              onClick={this.onDelete}
            >
              <Image src={Forma} alt="Delet Icon" />
            </div>
          </div>
          <div className="forward-to-team-form-content">
            {(ACTION_TYPE === get(this.props, "actionType") && (
              <Form.Group
                className={files.length !== 0 ? "text-area" : "text-area1"}
              >
                {/* <Field
                  keyName="comment"
                  onChange={this.onChange}
                  onError={this.onError}
                  as="textarea"
                  rows="4"
                  placeholder="Add Details"
                  isInvalid={get(error, "comment.error")}
                />
                {/* {
                console.log("value.length", value.length)} */}
                {/* {this.state.comment !== null &&
                  this.state.comment !== undefined &&
                  this.state.comment.length === 0 && (
                    <span
                      className="required"
                      style={{
                        position: "absolute",
                        left: "14.5%",
                        paddingTop: "6px"
                      }}
                    >
                      *
                    </span>
                  )} */}
                <Field
                  keyName="comment"
                  onChange={this.onChange}
                  onError={this.onError}
                  as="textarea"
                  rows="4"
                  onBlur={this.onBlur}
                  isInvalid={get(error, "comment.error")}
                />
                {this.state.comment == "" ? (
                  <>
                    <label
                      for="some-id"
                      class={
                        files.length !== 0
                          ? "textfield-reject__label textfield-reject__label--required"
                          : "textfield-fwd__label textfield-fwd__label--required"
                      }
                    >
                      Add Details
                    </label>
                  </>
                ) : (
                  <></>
                )}
              </Form.Group>
            )) ||
              null}
            {files.length !== 0 ? (
              <hr style={{ marginTop: "8px", marginBottom: "0px" }} />
            ) : null}
            <Form.Group className="field-attachment">
              <DisplayAttachments
                filesArr={files}
                //filesArr={meetingOm}
                onRemoveFile={this.onRemoveFile}
                addAttchementRequired={false}
                classes="attachments"
              />
            </Form.Group>
          </div>
          <div className="forward-to-team-footer">
            <div className="forward-to-team-buttons">
              <div className="add-attachment" onClick={this.onToggleAttachment}>
                <div
                  className="add-attachment-button"
                  //style={{ position: "relative", left: "-8px", top: "20px" }}
                >
                  <Image src={IconPin} alt="Attachment Icon" />
                  Add Attachment
                </div>
              </div>
              <div
                //style={{ position: "relative", left: "493%", bottom: "11px" }}
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  position: "relative"
                }}
              >
                <Button
                  className="btn-orange no-padding-send btn-reject"
                  onClick={this.onSend}
                  style={{ marginTop: "10px" }}
                >
                  {parentId ? "SUBMIT" : "SEND"}
                </Button>
              </div>
              {/* </div> */}
            </div>
          </div>
        </Form>

        {get(error, "comment.error") && (
          <span className="error-reject invalid-feedback">
            Mandatory fields are missing
          </span>
        )}

        {(showCommentPopUp && (
          <>
            <ConfirmationComponent
              show={showCommentPopUp}
              isLoading={false}
              modalClass={"confirmation-modal"}
              saveHandler={this.setIssueStatus}
              closeHandler={this.toggleMeetingPopUp}
              content={
                <div>
                  Are you sure you want to{" "}
                  {action == "REJECT ISSUE" || action == "REJECT"
                    ? "reject"
                    : null}{" "}
                  {action == "RESOLVE" ? "resolve" : null}{" "}
                  {action == "RESOLVED AND SEND TO STATE PMG" ||
                  action == "RESOLVED & SEND TO PMG"
                    ? "resolve and send"
                    : null}{" "}
                  the issue
                  {action == "RESOLVED & SEND TO PMG" ? " to PMG" : null}
                  {action == "RESOLVED AND SEND TO STATE PMG"
                    ? " to State PMG"
                    : null}
                  ?
                </div>
              }
            />
          </>
          // <div className="forward-to-team-confirmation">
          //   <div className="confirmation-inner">
          //     Are you sure you want to  <span className="action">{action}</span>{" "}
          //     the issue?
          //     <div className="confirmation-buttons">
          //       <Button className="btn-orange" onClick={this.setIssueStatus}>
          //         Yes
          //       </Button>
          //       <Button className="btn-orange-invert" onClick={this.onSend}>
          //         No
          //       </Button>
          //     </div>
          //   </div>
          // </div>
        )) ||
          null}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    isImageUpLoading: state.commonReducer.isImageUpLoading
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      setIssueStatusDispatch: setIssueStatusAction,
      getIssueListDispatch: getIssueList
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ChangeStatus);
